


























































import { Component, Prop, Mixins } from "vue-property-decorator";
import { IAddress } from "@/models/addresses";
import { IState } from "@/store";
import { mapState } from "vuex";
import { ICountry, IRegion } from "@/models/constants";
import { DataModules } from "@/store/modules/data";
import Context from "@/mixins/context";
import CountriesStore from "@/mixins/constants/countriesStore";
import RegionsStore from "@/mixins/constants/regionsStore";

@Component({
  computed: {
    ...mapState({
      regions(state: IState, getters) {
        return getters[`constants/getRegions`](
          this.$_.get(this.country, "code")
        );
      }
    })
  }
})
export default class UAddress extends Mixins(
  Context,
  CountriesStore,
  RegionsStore
) {
  @Prop({ required: true })
  public address!: IAddress;
  @Prop({ default: false })
  public isReadonly!: boolean;
  @Prop({ default: false })
  public isStaged!: boolean;
  @Prop({ default: true })
  public isMultiline!: boolean;
  @Prop({ default: false })
  public showDefault!: boolean;

  public dataModule: string = DataModules.CLIENTS_ADDRESSES;

  // Lifecycle methods

  public async created() {
    await this.getCountries();
    await this.regionsStoreLoadData({
      countryId: this.$_.get(this.country, "id"),
      countryCode: this.$_.get(this.country, "code")
    });
  }

  // Getters

  public get country(): ICountry | undefined {
    return this.$_.find(this.countries, ["id", this.address.country_id]);
  }

  public get region(): IRegion | undefined {
    return this.$_.find(this.regions, ["id", this.address.region_id]);
  }

  public get computedAddress() {
    return this.$_.compact([
      this.address.address_1,
      this.address.address_2,
      this.address.city,
      this.address.state,
      this.address.postcode,
      this.$_.get(this.region, "name"),
      this.$_.get(this.country, "name")
    ])
      .join(",\n")
      .trim();
  }

  // Methods

  public editAddress() {
    this.$store.dispatch(`data/${this.dataModule}/openEditModal`, {
      address: this.address,
      config: {
        events: {
          success: () => {
            this.$emit("edit");
          }
        }
      }
    });
  }

  public makeDefault() {
    return this.$store
      .dispatch(`data/${this.dataModule}/makeDefault`, {
        address: this.address
      })
      .then((onSuccess?: boolean) => {
        if (onSuccess) this.$emit("refresh");
      });
  }

  public deleteAddress() {
    return this.$store.dispatch(`data/${this.dataModule}/confirmDelete`, {
      address: this.address,
      onConfirm: () => {
        this.$emit("refresh");
        this.$emit("delete");
      }
    });
  }
}
